import TagManager from 'react-gtm-module';
import { useSelector } from 'react-redux';
import { getCurrentAccount } from '../../store/selectors/accountSelectors';
import {
  selectAuthUser,
  selectUserPhoneNumbers,
} from '../../store/selectors/userSelectors';
import { parseEnumType } from '../helpers/enumMappers';
import { accountTypeKeys } from '../enum/api/accountTypes';
import useWindowSize from './useIsMobileHook';

const DESKTOP_BREAKPOINT = 1200;

const useSfhGtmHook = () => {
  const currentAccount = useSelector(getCurrentAccount);
  const userInfo = useSelector(selectAuthUser);
  const phoneNumbers = useSelector(selectUserPhoneNumbers);
  const windowSize = useWindowSize();

  const platform =
    windowSize.width < DESKTOP_BREAKPOINT ? 'mobile_web' : 'desktop_web';

  const sfhGtmEvent = (eventName, eventData) => {
    const userName =
      [userInfo?.FirstName, userInfo?.LastName].filter(Boolean).join(' ') ||
      userInfo?.Username ||
      '';

    const phoneNumber = phoneNumbers?.[0];
    const userPhone = phoneNumber
      ? `${phoneNumber.AreaCode || ''}${phoneNumber.LocalNumber || ''}`
      : '';

    const data = {
      user_name: userName,
      user_email: userInfo?.Email || '',
      user_phone: userPhone,
      user_account_number: currentAccount?.AccountCode || '',
      user_account_type: parseEnumType(
        accountTypeKeys,
        currentAccount?.AccountType,
      ),
      user_account_status: currentAccount?.AccountStatus,
      platform,
      ...eventData,
    };

    TagManager.dataLayer({
      dataLayer: {
        event: eventName,
        eventData: data,
      },
    });
  };

  return { sfhGtmEvent };
};

export default useSfhGtmHook;
